import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsIdeasBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Ideas</div>
          <div className="text">
            An idea is an object that represents a feature request or feedback item. Ideas can be
            organized into groups, have parent-child relationships, and include custom fields. The
            API allows you to fetch a list of ideas with filtering, sorting, and pagination options.
          </div>
        </div>
        <div></div>
      </APIDocsBlock>
    );
  }
}
